import React, { useState } from 'react';
import Hero from '../components/Hero';
import { ChevronDown, MessageCircle, HelpCircle, ArrowRight, ShieldQuestion } from 'lucide-react';
import './Info.css';
import './Faqs.css';

const Faqs = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqData = [
        {
            category: "General",
            questions: [
                { q: "What is Bharatinsurex?", a: "Bharatinsurex is India's leading high-performance insurance platform providing elite protection across Life, Health, Motor, and Business categories with 100% digital transparency." },
                { q: "What documents do I need to buy a policy?", a: "Most of our elite plans require only your Aadhaar and PAN for instant 60-second issuance. Some specialized life or high-sum health plans may require basic income proof." },
                { q: "How long does it take for a claim to be settled?", a: "Our specialized claim settlement team aims to approve most motor and health claims within 60 minutes. Complex life insurance claims are typical processed within 4-48 working hours." }
            ]
        },
        {
            category: "Health & Life",
            questions: [
                { q: "What is Cashless Hospitalization?", a: "It's a high-authority service where Bharatinsurex pays the hospital directly for your treatment. You only pay for non-medical expenses. We have 10,000+ top hospitals in our elite network." },
                { q: "Can I increase my health cover later?", a: "Yes, our 'Elite Top-up' plans allow you to increase your coverage limits at any time during your policy term at competitive premiums." },
                { q: "Is COVID-19 covered under your health plans?", a: "Absolutely. All our high-performance health insurance plans provide comprehensive coverage for COVID-19 hospitalization and related treatments." }
            ]
        },
        {
            category: "Claims & Support",
            questions: [
                { q: "How do I file a claim?", a: "Simply visit our 'Elite Claims Terminal' in the mobile app or click the 'File Claim' button in the global footer. You can also call our 24/7 support experts at +91 96671 93590." },
                { q: "Are pre-existing diseases covered?", a: "Most of our elite plans cover pre-existing diseases after a high-performance waiting period of 2-4 years, depending on the specialized plan you choose." }
            ]
        }
    ];

    return (
        <div className="faq-page">
            <Hero 
                title="Knowledge Hub & FAQs"
                subtitle="Your most critical insurance questions answered with absolute professional clarity and technical transparency."
                bgGradient={true}
                image="/assets/faq-hero.png"
                imageAlt="Frequently Asked Questions illustration"
            />

            <section className="section-padding container">
                <div className="faq-terminal-grid">
                    <div className="faq-categories">
                        <div className="category-sticky">
                            <h3>Topic Horizons</h3>
                            {faqData.map((cat, i) => (
                                <button key={i} className="faq-cat-btn">
                                    <ArrowRight size={16} /> {cat.category}
                                </button>
                            ))}
                            <div className="faq-side-cta glass">
                                <MessageCircle size={32} />
                                <h4>Still have Questions?</h4>
                                <p>Our elite advisors are ready to help you navigate your insurance journey.</p>
                                <button className="btn btn-primary btn-sm" onClick={() => window.location.href='/contact'}>Talk to Experts</button>
                            </div>
                        </div>
                    </div>

                    <div className="faq-content-terminal">
                        {faqData.map((category, catIndex) => (
                            <div key={catIndex} className="faq-group-host">
                                <h2 className="faq-group-title">{category.category}</h2>
                                <div className="faq-list">
                                    {category.questions.map((item, qIndex) => {
                                        const globalIndex = `${catIndex}-${qIndex}`;
                                        const isActive = activeIndex === globalIndex;
                                        return (
                                            <div 
                                                key={qIndex} 
                                                className={`faq-item-card ${isActive ? 'active' : ''}`}
                                                onClick={() => toggleFaq(globalIndex)}
                                            >
                                                <div className="faq-question">
                                                    <span>{item.q}</span>
                                                    <ChevronDown size={20} className="faq-chevron" />
                                                </div>
                                                <div className="faq-answer">
                                                    <div className="faq-answer-inner">
                                                        {item.a}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="faq-footer-terminal glass">
                    <ShieldQuestion size={48} className="terminal-shield" />
                    <h3>Need Deep Technical Guidance?</h3>
                    <p>For complex business or high-net-worth life insurance, our relationship managers provide 1-on-1 strategy sessions.</p>
                    <div className="faq-footer-btns">
                        <a href="tel:+919667193590" className="btn btn-secondary">Call +91 96671 93590</a>
                        <a href="mailto:chandkhan03244@gmail.com" className="btn btn-primary">Email Our Strategy Team</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Faqs;
